import { FlexContainer, useDeviceSize } from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import { generatePath, useParams } from 'react-router-dom';
import { useData } from '../../providers';
import { RoutesName } from '../../states';
import { CardList, DataList } from '../cards/CardList';
import { GoBackHeader } from '../goBackHeader';
import { Banner } from './Banner';

export const OCR = () => {
  const { isMobile } = useDeviceSize();
  const { t } = useTranslation();
  const { operationId } = useParams();

  const { idCapturedState } = useData();

  const ocrDataArray = Object.entries(
    idCapturedState.data?.BACKSIDE.MRZ_DATA || {}
  );

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const data: any[] | undefined = ocrDataArray
    .filter((element) => element[0] != 'documentDataFieldsSerialized')
    .map((item) => ({
      title: item[0],
      value: item[1],
    }));

  const pdfData: DataList[] | undefined = data?.reduce(
    (acc: DataList[], dataField: DataList) => {
      dataField.title.includes('PDF') && acc.push(dataField);
      return acc;
    },
    []
  );

  return (
    <>
      <GoBackHeader
        route={generatePath(RoutesName.results, {
          operationId,
        })}
        linkLabel="Go back"
        title="Extracted data"
        linkId="ocr_detail_screen_back_button"
        idTitle="ocr_detail_screen_title_text"
      />
      <Banner idDocument="ocr_document_type_title_text" />
      <FlexContainer
        columnGap={isMobile ? '0' : '0.8'}
        rowGap={isMobile ? '0.8' : '0'}
        as="section"
        flexDirection={isMobile ? 'column' : 'row'}
      >
        <CardList
          title={t('MRZ Detail')}
          subTitle={t('MRZ') as string}
          data={data}
          loading={idCapturedState.loading}
          showEmptyState
          error={idCapturedState.error}
          testId="ocr_detail_screen_mrz_section"
        />

        {!!pdfData?.length && (
          <CardList
            title={t('PDF Detail')}
            subTitle={'PDF'}
            data={pdfData?.length ? pdfData : undefined}
            loading={idCapturedState.loading}
            showEmptyState
            error={idCapturedState.error}
            testId="ocr_detail_screen_pdf_section"
            fitContent
          />
        )}
      </FlexContainer>
    </>
  );
};
